import React, { memo, useContext } from 'react';
import Markdown from '../../../components/shared/Markdown';
import { safetyCheck } from '../../../utils';
import PageContext from '../../../contexts/PageContext';

const StrategicA = () => {
    const { data, heading: Heading } = useContext( PageContext );

    return (
        safetyCheck( data.strategic, 'body' ) && (
            <div>
                <Heading>{data.strategic.heading}</Heading>
                <Markdown className="markdown text-sm">{data.strategic.body}</Markdown>
            </div>
        )
    );
};

export default memo( StrategicA );
